const STORAGE_KEY = 'nacanaca-challenge-links-v1';

function loadChallengeLinks() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function saveChallengeToken(id, token) {
  try {
    if (!id || !token) return;
    const links = loadChallengeLinks();
    links[id] = token;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(links));
  } catch {
    // El servidor también guarda el token para retos nuevos.
  }
}

export function buildChallengeUrl(token) {
  return `${window.location.origin}/reto?token=${encodeURIComponent(token)}`;
}

export function resolvePendingChallengeUrl(challenge) {
  const token = challenge?.inviteToken || challenge?.token || loadChallengeLinks()[challenge?.id];
  return token ? buildChallengeUrl(token) : null;
}
